import moment from "moment";
import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import SectionNotesContent from "./SectionNotesContent";
import { toast } from "react-toastify";
// import { providerNoteApi, useSaveSectionTextMutation } from "app/redux/providerNoteService";
// import { useProcessSectionMutation } from "app/redux/documateService";
// import baseApiHelper from "app/redux/baseApiHelper";
import { cloneDeep, map } from "lodash";
// import { useSocketContext } from "app/context/socketContext";
// import { useProviderNoteContext } from "app/modules/ProviderNote/ProviderNoteContext";
// import { usePusherContext } from "app/context/pusherContext";
import { shallowEqual, useSelector } from "react-redux";
import NotesPreviewPopup from "./NotesPreviewPopup";
import { BiShow } from "react-icons/bi";
import MainPageDialog from "../../components/dialog";
import { AppListing } from "../../components/AppListing/Listing.view";
import LoadingBars from "../../components/loadingBar";
import {
  providerNoteApi,
  useSaveSectionTextMutation,
} from "../../services/providerNoteService";
import baseApiHelper from "../../services/baseApiHelper";
import { useProcessSectionMutation } from "../../services/documateService";
import { mergeArraysByKey } from "../ShareData/helper";

const SignedEncounterContent = ({
  selectedNote,
  pastSignedEncountersList,
  cancelSignedHandler,
  isSignedLoading,
  shareDataDetail,
  selectedChat,
}) => {
  const { setValue, control } = useForm();
  const [processSection] = useProcessSectionMutation();
  const [showSections, setShowSections] = useState(false);
  const [isLoadingNotes, setIsLoadingNotes] = useState(false);
  const [selectedEncounterID, setSelectedEncounterID] = useState(null);
  const [selectedEncounterSections, setSelectedEncounterSections] = useState(
    []
  );
  const [showPopup, setShowPopup] = useState(false);
  const [notesData, setNotesData] = useState(null);

  const [getNotesSectionsTrigger] =
    providerNoteApi.endpoints.getNotesSections.useLazyQuery();
  const [fetchNotesPreview, { isFetching: isLoadingPreview }] =
    providerNoteApi.endpoints.getNotesPreview.useLazyQuery();
  const [saveNoteTextTrigger] = useSaveSectionTextMutation();

  // const socketContext = useSocketContext();
  // const socketContextProvider = useMemo(() => ({
  //   setSocketNoteSections: socketContext.setSocketNoteSections,
  //   broadcastNoteData: socketContext.broadcastNoteData,
  // }));

  // const providerNoteContext = useProviderNoteContext();
  // const providerNoteProvider = useMemo(() => ({
  //   setIsTabLoading: providerNoteContext.setIsTabLoading,
  // }));

  // const pusherContext = usePusherContext();
  // const { setPusherData } = useMemo(() => ({
  //   setPusherData: pusherContext.setPusherData,
  // }));

  const fetchNotesTableData = (encounter) => {
    fetchNotesPreview({
      encounter: encounter,
      include_addendum_in_preview: 1,
    }).then((res) => {
      setNotesData(res?.data?.response?.data);
    });
  };

  const cols = [
    {
      title: "Encounter Date",
      key: "date",
      colWidth: "2",
      getData: (item) => {
        return (
          <p
          // style={{ color: "#007dda" }}
          // onClick={() => handleNotesSections(item?.id)}
          >
            {moment(item?.date, "YYYY-MM-DD hh:mm:ss").format(
              "MM/DD/YYYY hh:mm A"
            )}
          </p>
        );
      },
    },
    {
      title: "Visit Reason",
      key: "visit_reason",
      colWidth: "2",
      getData: (item) => {
        return item?.visit_reason && item?.visit_reason !== ""
          ? item?.visit_reason
          : "-";
      },
    },
    {
      title: "Encounter Type/ID",
      key: "encounter_type_title",
      colWidth: "2",
      getData: (item) => {
        return (
          <div className="flex flex-col justify-center align-middle">
            <p>{item?.encounter_type_title}</p>{" "}
            <p style={{ color: "#008000b0" }}>{item?.serial_number}</p>
          </div>
        );
      },
    },
    {
      title: "Provider",
      key: "provider_name",
      colWidth: "2",
      getData: (item) => {
        return (
          <div className="flex flex-col justify-center align-middle">
            <p>{item?.signed_by_name}</p> <p>{item?.specialty}</p>
          </div>
        );
      },
    },
    {
      title: "Location",
      key: "location",
      colWidth: "2",
      getData: (item) => {
        return item?.Location?.name;
      },
    },
    {
      title: shareDataDetail ? "Preview" : "Encounter Status",
      key: "status",
      colWidth: "2",
      textAlign: "text-right",
      getData: (item) => {
        return (
          <>
            {shareDataDetail ? (
              <div
                onClick={() => (
                  fetchNotesTableData(item?.encounter), setShowPopup(true)
                )}
              >
                <BiShow className="size-7 ml-5 text-[#0066FF]" />
              </div>
            ) : (
              <p className="py-1 px-2.5 font-normal border border-bgGreen rounded bg-bgGreen text-[14px] text-white inline-block capitalize">
                {item?.status}
              </p>
            )}
          </>
        );
      },
    },
  ];

  const handleNotesSections = (id) => {
    setShowSections(true);
    setIsLoadingNotes(true);
    setSelectedEncounterID(id);
    getNotesSectionsTrigger({ id }).then((res) => {
      setIsLoadingNotes(false);
      if (res?.data?.notes?.length > 0) {
        let response = cloneDeep(res?.data?.notes).map((sec) => {
          sec.selected = false;
          if (
            sec.slug == "assessment" ||
            sec.slug == "plan" ||
            sec.slug == "assessment_and_plan"
          ) {
            if (
              sec?.note_health_conditions &&
              sec?.note_health_conditions?.length > 0
            ) {
              sec.note_health_conditions = map(
                sec?.note_health_conditions,
                function (hc) {
                  hc.selected = false;
                  return hc;
                }
              );
            }
          }
          return sec;
        });

        setSelectedEncounterSections(response);
      } else {
        setShowSections(false);
        toast.error("There is nothing to import");
      }
    });
  };

  const cancelNotesHandler = () => {
    setShowSections(false);
    setSelectedEncounterSections([]);
  };

  const closeDialogues = () => {
    cancelNotesHandler();
    cancelSignedHandler();
    setSelectedEncounterSections([]);
  };

  // const updateLocalStoresAndSocket = (response, updatedSlugs) => {
  //   // updating, pusher data
  //   if (response?.data?.code == 0 && response?.data?.meta) {
  //     let metaData = cloneDeep(response?.data?.meta);
  //     if (metaData.updated_sections) {
  //       delete metaData.updated_sections;
  //     }
  //     if (updatedSlugs && updatedSlugs.length > 0) {
  //       metaData.tabs_data = metaData.tabs_data?.map((tab) => {
  //           tab.sections = tab?.sections?.map((section) => {
  //               section.socket_update = updatedSlugs.indexOf(section.slug) > -1;
  //               return section;
  //           });
  //           return tab;
  //       });
  //     }
  //     if (
  //       metaData?.auto_accept_response &&
  //       metaData?.auto_accept_response?.health_conditions
  //     ) {
  //       if (!metaData.clinical_data) {
  //         metaData.clinical_data = {};
  //       }
  //       metaData.clinical_data.health_conditions = metaData?.auto_accept_response?.health_conditions;
  //     }
  //     metaData = {...metaData, notes: metaData?.tabs_data};
  //     setPusherData(metaData);
  //     socketContextProvider.broadcastNoteData("e10x_save_text", metaData);
  //     socketContextProvider.setSocketNoteSections(metaData?.notes);
  //     baseApiHelper().updateNoteSliceField(false, false, metaData);
  //   }
  // };

  // const handleSaveNotesText = () => {
  //   let selectedItems = selectedEncounterSections?.filter(
  //     (item) =>
  //       item.selected ||
  //       (item?.note_health_conditions &&
  //         item?.note_health_conditions?.filter((prb) => prb.selected)?.length > 0)
  //   );

  //   if (selectedItems?.length > 0) {
  //     let updatedNotes = [];
  //     let updatedSlugs = [];
  //     let updatedSections = cloneDeep(selectedNote.notes);
  //     let checkExtraHXchecked = selectedItems.filter((item) => {
  //         return (item.selected && (item.slug?.indexOf('_history') > -1 || item.slug?.indexOf('_histories') > -1) && updatedSections?.findIndex((tab) => {
  //             return tab?.sections?.findIndex((sec) => {
  //                 return sec?.slug==item.slug
  //             }) > -1
  //         }) < 0);
  //     });
  //     if (checkExtraHXchecked?.length > 0) {
  //       let hxIndex = updatedSections?.findIndex((tab) => {
  //         return tab?.slug == "hx";
  //       });
  //       if (hxIndex > -1) {
  //         updatedSections[hxIndex].sections = updatedSections[hxIndex].sections.concat(checkExtraHXchecked);
  //       }
  //     }
  //     setTimeout(() => {
  //       updatedSections = updatedSections.map((section) => {
  //         section?.sections?.map((note) => {
  //           if (note && note?.slug) {
  //             let tempCheck = selectedItems.find(
  //               (temp) =>
  //                 note?.slug == temp?.slug ||
  //                 (note?.slug == "assessment_and_plan" &&
  //                   (temp?.slug == "assessment" ||
  //                     temp?.slug == "plan" ||
  //                     temp?.slug == "assessment_and_plan"))
  //             );
  //             if (tempCheck) {
  //               let prevText = note?.note_text;
  //               if (tempCheck?.note_text && (
  //                 practice_id == '1104' ||
  //                 (tempCheck?.slug == "physical_examination" || tempCheck?.slug == "review_of_systems")
  //               )) {

  //                 if (tempCheck?.slug == "physical_examination" || tempCheck?.slug == "review_of_systems") {
  //                   note.systems = "";
  //                 }
  //                 note.note_text = tempCheck?.note_text;

  //               } else {
  //                 note.note_text += (prevText?.length ? "\n" : "") + tempCheck?.note_text;
  //               }

  //               if (tempCheck?.skip_note_text) {
  //                 note.skip_note_text = tempCheck?.skip_note_text;
  //               }

  //               if (
  //                 tempCheck?.slug == "assessment" ||
  //                 tempCheck?.slug == "plan" ||
  //                 tempCheck?.slug == "assessment_and_plan"
  //               ) {
  //                 note.note_label_data = cloneDeep(tempCheck?.note_health_conditions)?.map((prb) => {
  //                   return {
  //                     title: prb?.code + ' - ' + prb?.title,
  //                     slug: tempCheck?.slug,
  //                     selected: prb?.selected,
  //                   };
  //                 });
  //                 note.note_health_conditions = tempCheck?.note_health_conditions
  //                   ? tempCheck?.note_health_conditions
  //                   : "";
  //                 note.note_label = tempCheck?.note_label
  //                   ? tempCheck?.note_label
  //                   : "";
  //               }
  //               updatedNotes.push(note);
  //               updatedSlugs.push(note?.slug);
  //             }
  //           }
  //           return note;
  //         });
  //         return section;
  //       });
  //       // providerNoteProvider.setIsTabLoading(true);
  //       saveNoteTextTrigger({
  //         pid: selectedNote?.pid,
  //         notes: updatedNotes,
  //         from_encounter: selectedEncounterID,
  //         encounter: selectedNote?.encounter,
  //         skip_xlu: 1
  //       }).then((res) => {
  //         if (res?.data?.code === 0) {
  //           updatedNotes.forEach(item => {
  //               if (item?.slug == 'medications') {
  //                   baseApiHelper().invalidateTags(["DocumateMedicationsList"]);
  //               }
  //               if (
  //                 item?.slug == 'past_medical_history' ||
  //                 item?.slug == 'social_history'
  //               ) {
  //                 //item?.slug == 'surgical_history'
  //                 //item?.slug == 'family_history'
  //                 processSection({section: {...item, text: item?.note_text}, pid: selectedNote?.pid, encounter: selectedNote?.encounter}).then((res) => {
  //                   if (res?.data?.response?.code == 0) {
  //                     let responseData = cloneDeep(res?.data?.response);
  //                     if (responseData?.data?.slug) {
  //                       let slugToPass = (responseData?.data?.slug == 'orders') ? 'medications' : (responseData?.data?.slug == 'referral') ? 'referrals' : (responseData?.data?.slug == 'assessments' || responseData?.data?.slug == 'assessment_and_plan') ? 'health_conditions' : (responseData?.data?.slug.indexOf('history') > -1 && responseData?.data?.slug!='past_medical_history') ? 'histories' : (responseData?.data?.slug=='follow_up') ? 'appointments' : responseData?.data?.slug;
  //                       let dataToUpdate = {};
  //                       if (responseData?.data?.data) {
  //                         dataToUpdate[slugToPass] = responseData?.data?.data;
  //                         baseApiHelper().invalidateThroughSocket(slugToPass, false, dataToUpdate);
  //                       }
  //                     }
  //                   }
  //                 });
  //               }
  //           });
  //           baseApiHelper().invalidateTags(["DocumateAssessmentsList"]);
  //           baseApiHelper().invalidateTags(["DocumateHistoriesList"]);
  //           // updateLocalStoresAndSocket(res, updatedSlugs);
  //         }
  //         // setTimeout(() => {
  //         //   providerNoteProvider.setIsTabLoading(false);
  //         // }, 2000);
  //       });
  //       closeDialogues();
  //     }, 250);
  //   } else {
  //     toast.error("Please select at least one section");
  //   }
  // };

  const footerSectionsList = [
    {
      title: "Close",
      type: "cancel",
      action: closeDialogues,
    },
    {
      title: "Back",
      type: "cancel",
      action: cancelNotesHandler,
    },
    // {
    //   title: "Import",
    //   type: "save",
    //   action: handleSaveNotesText,
    // },
  ];

  return (
    <div>
      {showPopup && (
        <NotesPreviewPopup
          setShowPopup={setShowPopup}
          notesData={notesData}
          isLoadingPreview={isLoadingPreview}
        />
      )}
      {showSections && (
        <MainPageDialog
          title="Import Past Encounter Data"
          onCancelHandler={cancelNotesHandler}
          footer={true}
          footerList={footerSectionsList}
        >
          <SectionNotesContent
            cancelNotesHandler={cancelNotesHandler}
            isLoadingNotes={isLoadingNotes}
            control={control}
            selectedNote={selectedChat}
            selectedEncounterSections={selectedEncounterSections}
            setSelectedEncounterSections={setSelectedEncounterSections}
            setValue={setValue}
          />
        </MainPageDialog>
      )}

      {!isSignedLoading ? (
        <AppListing
          listData={
            shareDataDetail?.selectedFiles?.length > 0
              ? mergeArraysByKey(
                  pastSignedEncountersList,
                  shareDataDetail?.selectedFiles
                )
              : pastSignedEncountersList
          }
          cols={cols}
          listContainerCls="app-list-container-default"
          selection={true}
          toggleSelectItem={(data) => shareDataDetail?.setSelectedFiles(data)}
        />
      ) : (
        <LoadingBars />
      )}
    </div>
  );
};

export default SignedEncounterContent;
